// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__F65-0"};